'use client'

import React from 'react'
import dynamic from 'next/dynamic'
import type { InteractiveParticlesProps } from './InteractiveParticles'

const LazyParticles = dynamic(
  () => import('./InteractiveParticles').then((m) => m.InteractiveParticles),
  { ssr: false, loading: () => null },
)

export const HeroParticles: React.FC<InteractiveParticlesProps> = (props) => {
  return <LazyParticles {...props} />
}
